import React from 'react';
import TableRow from './tableRow';
import TableCell from './tableCell';
import { ActionsByColumnsType } from '../../core/helpers/actionsByColumnsType';
import { iframeService } from '../../services/iframeService';
import { isTopC } from '../../core/helpers/skinHelper';

function Table({ data, columns, rate, currency, precision, currentUserId, t }) {
  return (
    <div className='cpt-table'>
      <TableRow isHead>
        {columns?.map((el) => {
          if (!el.isShow) {
            return null;
          }
          return <TableCell rowInfo={t(el.title)} key={el.title} />;
        })}
      </TableRow>
      {data.map((spinInfo) => {
        return (
          <TableRow
            key={`${spinInfo.gameName}|${spinInfo.spinId || ''}|${spinInfo.id || ''}|${
              spinInfo.date || ''
            }|${spinInfo.time || ''}`}
          >
            {columns?.map(
              ({ isShow, dataKey, colRenderer, columnType, additionalInfoRenderer }) => {
                if (!isShow) {
                  return null;
                }
                const celInfo = ActionsByColumnsType[columnType](spinInfo[dataKey], {
                  spinInfo,
                  rate,
                  currentUserId,
                  precision, // TODO add spinInfo precision when backend done
                  currency,
                  dataKey,
                });
                return (
                  <TableCell
                    rowInfo={celInfo}
                    key={dataKey}
                    dataKey={dataKey}
                    spinInfo={spinInfo}
                    additionalStyle={dataKey === 'userId' && isTopC() ? 'pointer' : null}
                    additionalInfo={additionalInfoRenderer?.(spinInfo, t, currency) || null}
                    clickHandler={
                      dataKey === 'userId' && isTopC()
                        ? () => iframeService.sendOpenPlayerStat(spinInfo.spinId, spinInfo.gameId)
                        : null
                    }
                  >
                    {colRenderer?.(spinInfo, t)}
                  </TableCell>
                );
              }
            )}
          </TableRow>
        );
      })}
    </div>
  );
}

export default Table;
